// defs
import { TransformedProductInfo, TransformedWidgetInfo } from './types';

export const DEFAULT_PRODUCT_INFO: TransformedProductInfo = {
  deliveryInfo: '',
  images: [],
  priceInfo: { originalPrice: 0, discountedPrice: 0, discount: 0 },
  ratingsInfo: {
    rating: '',
    ratingsCount: '',
  },
  sizeGuideURL: '',
  inventoryNudge: '',
  sizeOptions: { title: '', options: [] },
  subTitle: '',
  tags: [],
  title: '',
  type: '',
  inStock: true,
  actionURL: '',
  id: '',
  sku: '',
};

export const RECO_WIDGET_TYPE = 'similar_products';

export const HYBRID_PDP_WIDGET_TYPES = {
  PAIR_IT_WITH: 'pair_it_with',
  SIMILAR_PRODUCTS: 'similar_products',
  CUSTOMER_ALSO_VIEWED: 'cav',
  MORE_FROM_CATEGORY: 'more_from_category',
  MORE_FROM_BRAND: 'more_from_brand',
  RECENTLY_VIEWED: 'recently_viewed',
};

export const HYBRID_PDP_WIDGET_TITLES: Record<string, string> = {
  [HYBRID_PDP_WIDGET_TYPES.PAIR_IT_WITH]: 'Pair It With',
  [HYBRID_PDP_WIDGET_TYPES.SIMILAR_PRODUCTS]: 'Similar Products',
  [HYBRID_PDP_WIDGET_TYPES.CUSTOMER_ALSO_VIEWED]: 'Customer Also Viewed',
  [HYBRID_PDP_WIDGET_TYPES.MORE_FROM_CATEGORY]: 'More from Category',
  [HYBRID_PDP_WIDGET_TYPES.MORE_FROM_BRAND]: 'More from Brand',
  [HYBRID_PDP_WIDGET_TYPES.RECENTLY_VIEWED]: 'Recently Viewed',
};

export const HYBRID_PDP_WIDGETS = [
  {
    type: HYBRID_PDP_WIDGET_TYPES.SIMILAR_PRODUCTS,
    title: HYBRID_PDP_WIDGET_TITLES[HYBRID_PDP_WIDGET_TYPES.SIMILAR_PRODUCTS],
  },
  {
    type: HYBRID_PDP_WIDGET_TYPES.CUSTOMER_ALSO_VIEWED,
    title: HYBRID_PDP_WIDGET_TITLES[HYBRID_PDP_WIDGET_TYPES.CUSTOMER_ALSO_VIEWED],
  },
  {
    type: HYBRID_PDP_WIDGET_TYPES.MORE_FROM_CATEGORY,
    title: HYBRID_PDP_WIDGET_TITLES[HYBRID_PDP_WIDGET_TYPES.MORE_FROM_CATEGORY],
  },
  {
    type: HYBRID_PDP_WIDGET_TYPES.MORE_FROM_BRAND,
    title: HYBRID_PDP_WIDGET_TITLES[HYBRID_PDP_WIDGET_TYPES.MORE_FROM_BRAND],
  },
];

export const DEFAULT_WIDGET_INFO: TransformedWidgetInfo = {
  fetchMoreProducts: false,
  products: [],
  pageNumber: 1,
  title: '',
  actionURL: '',
  widgetType: '',
  showViewAll: false,
};
